import { render } from "./EditaCampanaForm.vue?vue&type=template&id=45520604&scoped=true"
import script from "./EditaCampanaForm.vue?vue&type=script&lang=js"
export * from "./EditaCampanaForm.vue?vue&type=script&lang=js"

import "./EditaCampanaForm.vue?vue&type=style&index=0&id=45520604&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45520604"]])

export default __exports__